import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { getCompoundEntityRef } from '@backstage/catalog-model';
import { entityUtil } from '@appfolio/backstage-plugin-catalog-common';
import { ANNOTATION_PACKAGE_TYPE } from '@appfolio/backstage-plugin-catalog-common';
import { EntityRefOption } from '../types';

export const useGemEntityRefOptions = () => {
  const catalog = useApi(catalogApiRef);
  const {
    data: options = [],
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['repos'],
    queryFn: async (): Promise<EntityRefOption[]> => {
      const { items } = await catalog.getEntities({
        // Gems are auto-ingested under the GitHub org that owns their source
        // repository (falling back to the default namespace), so this must not
        // pin metadata.namespace — doing so would drop every org-namespaced gem.
        filter: {
          kind: 'Component',
          [`metadata.annotations.${ANNOTATION_PACKAGE_TYPE}`]: 'gem',
        },
        fields: [
          'kind',
          'metadata.name',
          'metadata.namespace',
          'metadata.title',
        ],
      });
      return items.map(i => ({
        ...getCompoundEntityRef(i),
        label: entityUtil(i).humanize(),
      }));
    },
  });
  return {
    options,
    isLoading,
    isFetching,
    isError,
    error: error as Error,
  };
};
